import { TEMP_WORKER_DOCUMENT_TYPE } from '@/typings/enums/TEMP_WORKER_DOCUMENT_TYPE';

type TempWorkerDocumentDescriptionsCoreType = {
  title: string
  description: string
  isRequired: boolean
  max: number
  icon: string
}

export const tempWorkerDocumentDescriptionsCore: Record<TEMP_WORKER_DOCUMENT_TYPE, TempWorkerDocumentDescriptionsCoreType> = {
	[TEMP_WORKER_DOCUMENT_TYPE.IdentityPiece]: {
		title: `Pièce d'identité`,
		description: `Vous devez obligatoirement fournir une pièce d'identité`,
		isRequired: true,
		max: 1,
		icon: 'interface-user-identifier',
	},
	[TEMP_WORKER_DOCUMENT_TYPE.CurriculumVitae]: {
		title: `Curriculum Vitae`,
		description: `Nous vous recommandons de fournir un CV`,
		isRequired: false,
		max: 1,
		icon: 'business-user-curriculum',
	},
	[TEMP_WORKER_DOCUMENT_TYPE.Diploma]: {
		title: `Diplômes`,
		description: `Nous vous recommandons de fournir un diplôme`,
		isRequired: false,
		max: 10,
		icon: 'certified-diploma',
	},
	[TEMP_WORKER_DOCUMENT_TYPE.DriverLicence]: {
		title: `Permis de conduire`,
		description: `Nous vous recommandons de fournir votre permis de conduire`,
		isRequired: false,
		max: 1,
		icon: 'driver-licence',
	},
	[TEMP_WORKER_DOCUMENT_TYPE.AddressProof]: {
		title: `Justificatif de domicile`,
		description: `Vous devez obligatoirement fournir un justificatif de domicile`,
		isRequired: true,
		max: 1,
		icon: 'common-file-text-home',
	},
	[TEMP_WORKER_DOCUMENT_TYPE.Iban]: {
		title: `RIB / IBAN`,
		description: `Vous devez obligatoirement fournir un RIB ou un IBAN`,
		isRequired: true,
		max: 1,
		icon: 'saving-piggy-coins',
	},
	[TEMP_WORKER_DOCUMENT_TYPE.SocialCertificate]: {
		title: `Attestation de sécurité sociale`,
		description: `Vous devez obligatoirement fournir une attestation de sécurité sociale`,
		isRequired: true,
		max: 1,
		icon: 'insurance-card',
	},
	[TEMP_WORKER_DOCUMENT_TYPE.Custom]: {
		title: 'Documents personnalisés',
		description: `Tout type de document que vous souhaiteriez partager avec vos agences`,
		isRequired: false,
		max: 10,
		icon: 'interface-content-file',
	},
};

export const identityPieceType = {
	IdentityCard: 0,
	Passport: 1,
	ResidentPermit: 2,
} as const;

export function getReadableIdentityPieceType (identityPieceTypeNum: typeof identityPieceType[keyof typeof identityPieceType]) {
	switch (identityPieceTypeNum) {
	case identityPieceType.IdentityCard:
		return `Carte d'identité`;
	case identityPieceType.ResidentPermit:
		return `Carte de séjour`;
	case identityPieceType.Passport:
		return `Passeport`;
	}
}
